// extracted by mini-css-extract-plugin
export default {"left":"VczOjaSRICeLOOwsDRNg","right":"f6J6bf2UOq4eclKXSAZE"};